import { render, staticRenderFns } from "./surface_container.vue?vue&type=template&id=9b47eebc&scoped=true&"
import script from "./surface_container.vue?vue&type=script&lang=ts&"
export * from "./surface_container.vue?vue&type=script&lang=ts&"
import style0 from "./surface_container.vue?vue&type=style&index=0&id=9b47eebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b47eebc",
  null
  
)

export default component.exports